//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {storageRef} from '../../../../firebase';
import {connect} from 'react-redux';

//import Components
import {Button, Input } from 'reactstrap';

import * as validations from '../../ProductManager/Category/Product/InputValidation';
//import CSS

import * as imageActions from '../../actions/imageActions'

import './ImageSelector.css'

class ImageSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reload : true,
            editing : false,
            image : null,
            file : '',
            url : '',
            loadingStatus : '',
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(!prevState.reload && this.state.reload) {
            this.loadImageFromStorage();
        }
        if(prevProps.imageId !== this.props.imageId){
            this.loadImageFromStorage();
        }
    }

    loadImageFromStorage = () => {
        const {storagePath, imageId } = this.props;
        const subfix = this.props.subfix ? `_${this.props.subfix}` : '';

        this.props.onLoadImage(storagePath, imageId, subfix, 
            () => {
                this.setState({
                    file : '',
                    url : '',
                    loadingStatus : '로딩을 시작합니다'
                })
            },
            (url) => {
                this.setState((prevState) => ({
                    url, 
                    reload : !prevState.reload
                }))
            },
            (e) => {
                this.setState((prevState) => ({
                    reload : !prevState.reload,
                    loadingStatus : '로딩을 실패했습니다'
                }))
            });
    }


    componentDidMount() {
        this.loadImageFromStorage();
    }

    isFileInputValid = () => {
        return validations.checkFileInput(this.state.file);
    }

    toggleImgEditing = () => {
        this.setState(prevState => ({
            editing : !prevState.editing,
            file : null,
            image : null
        }))
    }
    handleOnFileChange = (e) => {
        if(e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (event) => {
                this.setState({
                    image : event.target.result,
                    file
                })
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    render() {
        const renderImgFromDatabase = this.state.url === '' ?
                                        <div className="selector-image">{this.state.loadingStatus}</div> :
                                        <img className="selector-image" src={this.state.url} alt={this.state.url}/>
        const renderImgFromLocal = <img className="selector-image" src={this.state.image} />

        return (
            <div className="img-editor">
                {
                    this.state.editing ? 
                        renderImgFromLocal : renderImgFromDatabase
                }
                {
                    this.state.editing ? (
                        <div>
                            <Input
                                type="file"
                                name="file"
                                id="seletor-img"
                                onChange={this.handleOnFileChange}
                                bsSize="sm"
                            />
                            <Button
                                onClick={() => {
                                    console.log(this.props.subfix);

                                    this.props.onUpdateImage(this.props.storagePath, 
                                                             this.props.imageId, 
                                                             this.props.subfix, 
                                                             this.state.file, 
                                                             () => {
                                                                 this.toggleImgEditing();
                                                             },
                                                             () => {
                                                                 this.setState((prevState) => ({
                                                                     reload: !prevState.reload
                                                                 }))
                                                             },
                                                             (e) => {
                                                                 global.alert("이미지를 변경하는데 실패했습니다.");
                                                             });
                                }}
                                color="warning"
                                size="sm"
                                disabled={!this.isFileInputValid()}
                                outline
                            >
                                확인
                            </Button>
                            <Button
                                onClick={this.toggleImgEditing}
                                color="danger"
                                size="sm"
                                outline
                            >
                                취소
                            </Button>
                        </div>
                        )
                        : (
                            <div>
                                <Button
                                    color="info"
                                    onClick={this.toggleImgEditing}
                                    size="sm"
                                    outline
                                >
                                    이미지편집
                                </Button>
                            </div>
                        )

                }
            </div>
        );
    }
}

// const mapStateToProps = () => {

// }

const mapDispatchToProps = (dispatch) => {
    return {
        onDeleteImage : (storagePath, id, successFunc, failedFunc) => {
            dispatch(imageActions.deleteImage(storagePath, id, successFunc, failedFunc));
        },
        onLoadImage : (storagePath, id, subfix, beforeLoadFunc, successFunc, failedFunc) => {
            dispatch(imageActions.loadImage(storagePath, id, subfix, beforeLoadFunc, successFunc, failedFunc));
        },
        onUpdateImage : (storagePath, id, subfix, file, beforeUpdateFunc, successFunc, failedFunc) => {
            dispatch(imageActions.updateImage(storagePath, id, subfix, file, beforeUpdateFunc, successFunc, failedFunc));
        },
        onUpdateImages : (storagePath, id, files, prevCount, beforeUpdateFunc, successFunc, failedFunc) => {
            dispatch(imageActions.updateImages(storagePath, id, files, prevCount, beforeUpdateFunc, successFunc, failedFunc));
        }
    }
}


export default connect(null, mapDispatchToProps)(ImageSelector);

ImageSelector.propTypes = {
    storagePath : PropTypes.string.isRequired,
    imageId : PropTypes.string.isRequired,     
    multiple : PropTypes.bool,

    subfix : PropTypes.string
}

ImageSelector.defaultProps = {
    multiple : false,
    subfix : ''
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Components/ImageSelector/ImageSelector.js